import HylyField from "storybookComponents/HylyField";
import { Formik } from "formik";

const CheckBox = ({ compactView, handleCompactView }) => (
  <Formik initialValues={{ field: [] }}>
    {(props) => {
      return (
        <HylyField
          variant="selector-checkbox"
          no_label={true}
          name="field"
          value={compactView ? ["Compact View"] : [""]}
          values={["Compact View"]}
          handleChange={handleCompactView}
        />
      );
    }}
  </Formik>
);

export default CheckBox;
